var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('media-filelist',{attrs:{"media-items":_vm.media || [],"permission-to-delete":_vm.canDelete,"show-download-btn":true},on:{"deleteFile":function($event){return _vm.$emit('deleteFile', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }